import { createSlice } from '@reduxjs/toolkit';
import { formatISO, subDays } from 'date-fns';

export const treatmentPlanSlice = createSlice({
  name: 'treatmentPlan',
  initialState: {
    tPlanPeriodFilter: {
      name: '90D',
      startDate: formatISO(subDays(new Date(), 90)),
      endDate: formatISO(new Date()),
    },
    treatmentGrid: {
      chartSerch: '',
      patSerch: '',
      dateAdded: '',
      reviewDate: '',
      provId: '',
      provSignSt: '',
      superVisor: '',
      superVisorSignSt: '',
      patSignSt: '',
      actionSt: '',
      serviceCode: '',
      billSt: '',
    },
  },
  reducers: {
    setTplanPeriod: (state, action) => {
      state.tPlanPeriodFilter = action.payload;
    },
    updateTplanSerch: (state, action) => {
      const { key, value } = action.payload;
      if (Object.prototype.hasOwnProperty.call(state.treatmentGrid, key)) {
        state.treatmentGrid[key] = value;
      }
    },
  },
});

export const { setTplanPeriod, updateTplanSerch } = treatmentPlanSlice.actions;
export default treatmentPlanSlice.reducer;
